import { Box, Button, Divider, Popover, Tooltip, Typography } from '@mui/material';
import React, { ReactElement, useMemo } from 'react';
import GroupIcon from '@mui/icons-material/Group';
import SiteOwnerDetails from './SiteOwnerDetails';
import EditIcon from '@mui/icons-material/Edit';
import { useAppSelector } from '../../hooks/hooks';
import { isEmployeeProjectManager, isEmployeeWarehouseManager } from '../../redux/selectors/employeeSelector';
import { useLocation } from 'react-router-dom';

type SiteOwnersPopoverProps = {
    warehouseOwners: string[];
    projectManagers: string[];
    handleOpenOwnerForm(): void;
};

export default function SiteOwnersPopover(props: SiteOwnersPopoverProps): ReactElement {
    const { warehouseOwners, projectManagers, handleOpenOwnerForm } = props;

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const myInfo = useAppSelector((state) => state.loggedEmployee.basicEmployee);

    const isWarehouseManager = useAppSelector(isEmployeeWarehouseManager);
    const isProjectManager = useAppSelector(isEmployeeProjectManager);

    const location = useLocation();
    const path = location.pathname;

    const isWarehousePage = useMemo(() => {
        return !!path && path.includes('/warehouses/');
    }, [path]);

    const isConstructonSitePage = useMemo(() => {
        return !!path && path.includes('/constructionSites/');
    }, [path]);

    const isProjectManagerOfTheProject = useMemo(() => {
        return myInfo?.id ? projectManagers.includes(myInfo?.id) : false;
    }, [projectManagers]);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openForm = () => {
        handleOpenOwnerForm();
        handleClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Box>
            <Tooltip title="Odgovorna lica">
                <Button aria-describedby={id} color="primary" onClick={handleClick}>
                    <GroupIcon />
                </Button>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'center', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                slotProps={{
                    paper: {
                        style: { borderRadius: 15 },
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, textAlign: 'center', width: 300, gap: 2 }}>
                    <Typography variant="h6">Odgovorna lica</Typography>
                    <Divider />
                    <Box>
                        {warehouseOwners.map((ownerId) => {
                            return <SiteOwnerDetails key={ownerId} siteOwnerId={ownerId} />;
                        })}
                    </Box>
                    {((isWarehouseManager && isWarehousePage) ||
                        (isConstructonSitePage && isProjectManager && isProjectManagerOfTheProject)) && (
                        <>
                            <Divider />
                            <Button color="primary" onClick={openForm}>
                                <EditIcon />
                            </Button>
                        </>
                    )}
                </Box>
            </Popover>
        </Box>
    );
}
